"use strict";
exports.__esModule = true;
exports.webStorageRemoveItem = exports.webStorageSetItem = exports.webStorageClear = void 0;
var t = require("io-ts");
var basic_1 = require("./util/basic");
var createReqRes_1 = require("../request-handler/createReqRes");
var webStorageType = t.union([
    t.literal('sessionStorage'),
    t.literal('localStorage'),
]);
// Originating FROM web
exports.webStorageClear = (0, createReqRes_1.createReqRes)('webStorageClear', t.type({
    storageType: webStorageType
}), basic_1.genericStatusMessage);
exports.webStorageSetItem = (0, createReqRes_1.createReqRes)('webStorageSetItem', t.type({
    key: t.string,
    value: basic_1.primitiveValue,
    storageType: webStorageType
}), basic_1.genericStatusMessage);
exports.webStorageRemoveItem = (0, createReqRes_1.createReqRes)('webStorageRemoveItem', t.type({
    key: t.string,
    storageType: webStorageType
}), basic_1.genericStatusMessage);
//# sourceMappingURL=storage.js.map